module.exports = __webpack_public_path__ + "static/media/icon-support-type-live.69a84616.svg";